// What Auth0 said when it refused a sign-in, in words a colleague can act on.
//
// An org subdomain signs in with `organization` set, and the org requires
// membership. Auth0 sends a user who is not a member back to the app with
// an error ("user … is not part of the org_… organization"). The login gate
// used to drop that error and offer "Sign in" again, which reused the same
// Auth0 session and failed the same way: a loop with no explanation
// (2026-10-12, a North Ammonia colleague). The retry therefore forces the
// login page, so another account can be used.
import React from 'react';

export const RETRY_LOGIN = { authorizationParams: { prompt: 'login' } };

export function isNotOrgMember(error) {
  const m = String(error?.message || error?.error_description || '');
  return /not part of the .*organization|not a member of/i.test(m);
}

export default function LoginRefusal({ error, orgName }) {
  if (!error) return null;
  const who = orgName || 'this organisation';
  return (
    <div className="login-gate-error" role="alert">
      <p>
        {isNotOrgMember(error)
          ? `This account is not a member of ${who} yet. Ask the person who gave you access to add it, then sign in again.`
          : 'Sign-in did not go through.'}
      </p>
      <p className="login-gate-error-detail">{String(error.message || error)}</p>
    </div>
  );
}
